import httpManager from "../../util/common"
import {reportTrans} from "./report_trans"
import XEUtils from 'xe-utils'


export default{
  props: {
    product_ids: Array,
    report_period: String,
    compare_content: String,
    select_event: Boolean
  },
  data() {
    return {
      gridOptions: {
        border: false,
        showOverflow: false,
        // height: 400,
        showHeader: false,
        columns: [],
        data: [],
        keepSource: true,
        exportConfig: {}
      },
      url: "",
      tableColumn: [],
      fund_indicator_table_column:[
        { field: 'ticker', title: '基金代码'},
        { field: 'short_name', title: '基金简称' },
        { field: 'full_name', title: '基金全称' },
        { field: 'investment_type', title: '投资性质' },
        { field: 'esg_strategy_type', title: 'ESG基金类型'},
        { field: 'report_period', title: '报告期'},
        { field: 'high_environmental_risk_ratio', title: '双高项目占比', showOverflow: true},
        { field: 'newenergy_patent_quality', title: '新能源技术专利质量', showOverflow: true},
        { field: 'newenergyvehicle_patent_quality', title: '新能源汽车技术专利质量', showOverflow: true },
        { field: 'greenbuilding_patent_quality', title: '绿色建筑技术专利质量', showOverflow: true },
        { field: 'ccus_patent_quality', title: 'CCUS技术专利质量', showOverflow: true },
        { field: 'wastemanagement_patent_quality', title: '废物管理技术专利质量', showOverflow: true },
        { field: 'energysaving_patent_quality', title: '节能技术专利质量', showOverflow: true },
        { field: 'yield_7d', title: '7天收益率', showOverflow: true },
        { field: 'yield_30d', title: '30天收益率', showOverflow: true },
        { field: 'yield_90d', title: '90天收益率', showOverflow: true },
        { field: 'yield_180d', title: '180天收益率', showOverflow: true },
        { field: 'yield_52w', title: '52周收益率', showOverflow: true },
        { field: 'yield_accumulated', title: '累计收益率', showOverflow: true },
        { field: 'yield_annual', title: '平均年化收益率', showOverflow: true },
      ],
      fund_rating_table_column:[
        { field: 'ticker', title: '基金代码'},
        { field: 'short_name', title: '基金简称' },
        { field: 'full_name', title: '基金全称' },
        { field: 'product_manager', title: '基金管理人' },
        { field: 'investment_type', title: '投资性质' },
        { field: 'esg_strategy_type', title: 'ESG基金类型'},
        { field: 'report_period', title: '报告期'},
        { field: 'asset_type', title: '资产类别'},
        { field: 'esg_score', title: 'ESG评分', showOverflow: true},
        { field: 'environmental_score', title: '环境得分', showOverflow: true },
        { field: 'social_score', title: '社会责任得分', showOverflow: true },
        { field: 'governance_score', title: '治理得分', showOverflow: true },
        { field: 'yield_7d', title: '7天收益率', showOverflow: true },
        { field: 'yield_30d', title: '30天收益率', showOverflow: true },
        { field: 'yield_90d', title: '90天收益率', showOverflow: true },
        { field: 'yield_180d', title: '180天收益率', showOverflow: true },
        { field: 'yield_52w', title: '52周收益率', showOverflow: true },
        { field: 'yield_accumulated', title: '累计收益率', showOverflow: true },
        { field: 'yield_annual', title: '平均年化收益率', showOverflow: true },
      ],
      loading: false
    }
  },
  methods: {
    // 将对象中的数值型数据保留6位小数
    saveSixDecimal(obj) {
      
        for(let attr in obj) {
          if(this.compare_content == "fund_esg_indicators"){
            if(attr == "newenergy_patent_quality" || attr == "newenergyvehicle_patent_quality" || attr == "greenbuilding_patent_quality"
            || attr == "ccus_patent_quality" || attr == "wastemanagement_patent_quality" || attr == "energysaving_patent_quality" ) {

              obj[attr] = (obj[attr]||obj[attr] == 0) ? obj[attr].toFixed(6) : ''

            }else if(attr == "high_environmental_risk_ratio" || attr == "yield_7d" || attr =="yield_30d"
            || attr == "yield_90d" || attr == "yield_180d" || attr == "yield_52w"
            || attr == "yield_accumulated" || attr == "yield_annual"){

              obj[attr] = (obj[attr]||obj[attr] == 0) ? obj[attr].toFixed(6) + "%" : ''

            }
          }else{
            if(attr == "esg_score" || attr == "environmental_score" || attr == "social_score"
            || attr == "governance_score" ) {

              obj[attr] = (obj[attr]||obj[attr] == 0) ? obj[attr].toFixed(6) : ''

            } else if(attr == "yield_7d" || attr =="yield_30d"
            || attr == "yield_90d" || attr == "yield_180d" || attr == "yield_52w"
            || attr == "yield_accumulated" || attr == "yield_annual"){

              obj[attr] = (obj[attr]||obj[attr] == 0) ? obj[attr].toFixed(6) + "%" : ''

            }
          }
            
          
        }
    },
    // 反转列表函数
    reverseTable (columns, list) {
      const buildData = columns.map(column => {
        const item = { col0: column.title }
        list.forEach((row, index) => {
          item[`col${index + 1}`] = row[column.field]
        })
        return item
      })
      const buildColumns = [{
        field: 'col0',
        fixed: 'left',
        width: 500
      }]
      list.forEach((item, index) => {
        buildColumns.push({
          field: `col${index + 1}`,
          minWidth: 120
        })
      })
      this.gridOptions.data = buildData
      this.gridOptions.columns = buildColumns
    },
    getFundData() {
      if(!this.report_period || !this.compare_content) {
        alert("请选择比较内容和报告期")
        return
      }
      let self = this
      
      let promises = []
      let dataList = []
      self.loading = true
      for(let i in self.product_ids) {
        let params = new Map()
        params.set("report_period", self.report_period)
        let product_id = self.product_ids[i]
        params.set("product_id", product_id)
        let promise = httpManager(self.url, params)
          .then(response => {
            let tempObj = response.data.data[0]
            this.saveSixDecimal(tempObj)
            // 检验是否重复
            if(i==0)
              dataList[i] = tempObj
            for(let j = 0; j < i; j++) {
              if(product_id != self.product_ids[j])
                dataList[i] = tempObj
            }
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
        promises.push(promise)
      }
      Promise.all(promises).then( ()=> {
        if(dataList&&dataList[0]) {
          reportTrans(dataList)
          self.reverseTable(self.tableColumn, dataList)
        }
      })
    },
    openDataExport() {
      let name = this.compare_content == "fund_esg_indicators"? "indicators" : "rating"
      let s = "Fund-ESG-" +  name + "-compare-" +this.report_period+"-"
      this.$refs.xTree.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: true,
        types: ['csv']
      })
    },
    
  },
  created() {
    if(this.compare_content == "fund_esg_indicators") {
      this.url = "fund_indicators"
      this.tableColumn = this.fund_indicator_table_column
    } else {
      this.url = "fund_rating"
      this.tableColumn = this.fund_rating_table_column
    }
  },
  watch: {
    select_event() {
      this.getFundData()
    },
    compare_content() {
      if(this.compare_content == "fund_esg_indicators") {
        this.url = "fund_indicators"
        this.tableColumn = this.fund_indicator_table_column
      } else {
        this.url = "fund_rating"
        this.tableColumn = this.fund_rating_table_column
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/fund_esg/js/fund_esg_compare_table.js